import { render, staticRenderFns } from "./RequestCreateModal.vue?vue&type=template&id=070e0992&scoped=true&"
import script from "./RequestCreateModal.vue?vue&type=script&lang=ts&"
export * from "./RequestCreateModal.vue?vue&type=script&lang=ts&"
import style0 from "./RequestCreateModal.vue?vue&type=style&index=0&id=070e0992&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e0992",
  null
  
)

export default component.exports